import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/common/data.service';
import { AppTokenHandler } from '../../common/app-token-handler';
import { Router } from '@angular/router';
@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.css']
})
export class ConsentComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,private _dataservice: DataService,private appTokenHandler:AppTokenHandler,private router:Router) { }
  consentForm: FormGroup;
  checked:boolean=false;
  userDetails: any;
  ngOnInit() {
    this.userDetails=this.appTokenHandler.getLoginUserInfo();
    this.consentForm = this.formBuilder.group({
      IsConsentAggred:[false,Validators.required]
  });
  }
  onSubmit() {
    if (this.consentForm.invalid) {
        return alert('Please select Consent.');
      }debugger
    this._dataservice.PostData("Common/SubmitConsent", {Param1:this.userDetails.EmpGPN}).subscribe((data: any) => {
      if(data.IsSuccess)
      {
          debugger;
          alert(data.Message);
          if (this.userDetails.DigiPitchID > 0) {
              this.router.navigate(['/home/SearchResume']);
          }
          else {
              this.router.navigate(['/home']);
          }
      }
    });
};
onConsentcheck(event){
debugger
this.checked=this.consentForm.controls.IsConsentAggred.value;
}
}
